module.exports = __webpack_public_path__ + "fonts/Raleway-Regular.75b4247f.ttf";